import { DatePipe } from "@angular/common";
import { Pipe, PipeTransform } from "@angular/core";
import { AppState } from "@app/app.module";
import { Store } from "@ngrx/store";
import { filter, first } from "rxjs/operators";

@Pipe({
    name: 'deTenantDateFormat',
    standalone: false
})
export class TenantDateFormatPipe extends DatePipe implements PipeTransform {
    tenantFormat: string;
    constructor(private store: Store<AppState>) {
        super('en-us');
        this.store.select(x => x.tenantSetting)
        .pipe(first())
        .subscribe(x => {
            this.tenantFormat = x.dateFormat;
            return '';
        });
    }
    
    transform(value: string | number | Date, format?: string, timezone?: string, locale?: string): string;
    transform(value: null, format?: string, timezone?: string, locale?: string): null;
    transform(value: string | number | Date, format?: string, timezone?: string, locale?: string): string;
    transform(value: any, format?: string, timezone?: any, locale?: any): string {
        let result;
        if (format == 'long') {
            this.tenantFormat += ' hh:mm:ss a'
        }
        if (format == 'full') {
            this.tenantFormat += ' HH:mm:ss a (z)'
        }
        result = super.transform(value, this.tenantFormat, timezone, locale);
        return result;
    }

}